module.exports = __webpack_public_path__ + "img/retrospect-1-mobile.c5e08843.jpg";